export const FILTER_OPERATORS = [
  'EQUALS',
  'NOT_EQUALS',
  'GREATER_THAN',
  'GREATER_THAN_OR_EQUAL_TO',
  'LESS_THAN',
  'LESS_THAN_OR_EQUAL_TO',
  'IS_NULL',
  'IS_NOT_NULL',
  'LIKE',
  'NOT_LIKE',
] as const;

export const OPERATORS_WITHOUT_VALUE: FilterOperator[] = [
  'IS_NULL',
  'IS_NOT_NULL',
];

export type FilterOperator = (typeof FILTER_OPERATORS)[number];

export type FilterInput = {
  column: string;
  operator: FilterOperator;
  value?: string;
  and?: FilterInput[];
  or?: FilterInput[];
};

/** Custom FilterInput with id field used for {@link DataWidgetFiltersInput} */
export type DataWidgetFiltersInput = Omit<FilterInput, 'and' | 'or'> & {
  id: string;
  and?: DataWidgetFiltersInput[];
  or?: DataWidgetFiltersInput[];
};
